import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<p class=\"user-profile-hidden\">{{i18n \"user.profile_hidden\"}}</p>",{ moduleName: "discourse/templates/user/profile-hidden.hbs" })